import React from 'react';
import { Select } from 'antd';
import { InputType } from '../InputType';
import { FormContext } from '../FormContext';
import { FormId } from '../FormId';

const { Option } = Select;

export default function SelectInput() {
	const formContext = React.useContext(FormContext);
	const {
		rowOptions,
		formValuesById,
		setFormValuesById,
		formId,
		accountInfoForm,
	} = formContext;
	const { rowTypeData } = rowOptions;

	const onSelectChange = (value, id) => {
		var newFormValuesById = {
			...formValuesById,
			[id]: value,
		};

		if (formId === FormId.AccountInfo && id === 'country') {
			newFormValuesById['stateUS'] = accountInfoForm.states_US[0].id;
			newFormValuesById['stateCA'] = accountInfoForm.states_CA[0].id;
		}

		setFormValuesById(newFormValuesById);
	};

	const getStatesSelectData = () => {
		switch (formValuesById['country']) {
			case 'US':
				return rowTypeData.optionsUS;
			case 'CA':
				return rowTypeData.optionsCA;
			default:
				throw new Error('Invalid country.');
		}
	};

	const getSelectData = () => {
		switch (rowTypeData.inputType) {
			case InputType.StatesSelect:
				return getStatesSelectData();
			case InputType.Select:
				return rowTypeData;
			default:
				throw new Error('Invalid input type.');
		}
	};

	const selectData = getSelectData();

	return (
		<Select
			value={formValuesById[selectData.inputId]}
			dropdownMatchSelectWidth={false}
			onChange={value => onSelectChange(value, selectData.inputId)}>
			{selectData.selectOptions.map(o => (
				<Option key={o.id}>
					<span>{o.value}</span>
				</Option>
			))}
		</Select>
	);
}
